import React from 'react';
import HomeIcon from '@material-ui/icons/Home';
import EcoIcon from '@material-ui/icons/Eco';
import List from '@material-ui/core/List';
import { Link } from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';

const MainMenu: React.FC = () => (
  <List>
    <ListItem button component={Link} to="/">
      <ListItemIcon><HomeIcon /></ListItemIcon>
      <ListItemText primary="Home" />
    </ListItem>
    <ListItem button component={Link} to="/rec-registry">
      <ListItemIcon><EcoIcon /></ListItemIcon>
      <ListItemText primary="Rec Registry" />
    </ListItem>
  </List>
)

export default MainMenu;
